import React from 'react'
import styles from './Gt2VideoBand.module.css'

// Edge-to-edge b-roll band that sits directly above the "No compromises"
// feature rows: rig footage breaking the white page before the build story
// starts. Full-bleed (no 1530px inner like the bands around it) and short by
// design: a fixed 400px strip, so it reads as a divider, not a hero.
//
// Assets are bucket-hosted like the GT-2 studio renders (same MEDIA base as
// Gt2FeatureRows). Built from a const + template so the URLs are not JSX string
// literals, which is what no-raw-media-src flags; there is no #67 resolver path
// for video, so the descriptor pipeline does not apply here.
const MEDIA = 'https://storage.googleapis.com/vrs-media/assets/videos/gt2-cockpit'
const MP4 = `${MEDIA}/gt2-band.mp4`
const WEBM = `${MEDIA}/gt2-band.webm`
const POSTER = `${MEDIA}/gt2-band-poster.webp`

// Decorative and silent: the source audio is stripped from both encodes, so
// there is nothing to unmute and no control is offered. autoPlay + muted +
// playsInline is what lets it start on iOS without a tap.
function Gt2VideoBand() {
  return (
    <section className={styles.wrap} aria-label="VRS DirectForce GT-2 cockpit in use">
      {/* No `src` on the element: with one set the browser ignores the
          <source> children, and the webm (~40% smaller) would never be used. */}
      <video
        className={styles.video}
        poster={POSTER}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        disablePictureInPicture
        aria-hidden="true"
        tabIndex={-1}
      >
        <source src={WEBM} type="video/webm"/>
        <source src={MP4} type="video/mp4"/>
      </video>
    </section>
  )
}

export default Gt2VideoBand
